import { useEffect, useState } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import axios from 'axios';
import { CheckCircle2, Loader2, Home, Truck, FileText } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Navbar } from '../components/layout/Navbar';
import { Footer } from '../components/layout/Footer';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ReservationSuccessPage() {
  const { t } = useTranslation();
  const [params] = useSearchParams();
  const sessionId = params.get('session_id');
  const [status, setStatus] = useState(null);
  const [tries, setTries] = useState(0);

  useEffect(() => {
    if (!sessionId) return;
    let cancelled = false;
    const poll = async () => {
      try {
        const res = await axios.get(`${API}/reservations/status/${sessionId}`);
        if (cancelled) return;
        setStatus(res.data);
        if (res.data.payment_status !== 'paid' && tries < 12) {
          setTimeout(() => setTries(tries + 1), 2000);
        }
      } catch {}
    };
    poll();
    return () => { cancelled = true; };
  }, [sessionId, tries]);

  return (
    <div className="min-h-screen flex flex-col bg-slate-50">
      <Navbar />
      <main className="flex-1 flex items-center justify-center px-4 py-16">
        <div className="max-w-lg w-full bg-white rounded-2xl shadow-xl p-8 text-center" data-testid="reservation-success">
          {!status && (
            <>
              <Loader2 className="h-14 w-14 text-[#3b82f6] animate-spin mx-auto mb-4" />
              <h2 className="text-2xl font-black text-slate-900">{t('carvana.success.checking', 'Vérification du paiement...')}</h2>
            </>
          )}
          {status?.payment_status === 'paid' && (
            <>
              <div className="mx-auto w-20 h-20 bg-emerald-100 rounded-full flex items-center justify-center mb-4">
                <CheckCircle2 className="h-12 w-12 text-emerald-600" />
              </div>
              <h2 className="text-3xl font-black text-slate-900 mb-2">{t('carvana.success.reserved', 'Véhicule réservé!')}</h2>
              <p className="text-slate-600 mb-6">{t('carvana.success.subtitle', 'Nous vous contacterons dans les prochaines minutes pour finaliser votre achat 100% en ligne.')}</p>
              <div className="grid grid-cols-1 gap-3 text-xs text-slate-700 mb-8 max-w-xs mx-auto">
                <div className="p-3 bg-slate-50 rounded-lg"><FileText className="h-6 w-6 text-[#3b82f6] mx-auto mb-1" />{t('carvana.success.step2', 'Financement finalisé')}</div>
              </div>
              <Link to="/" className="inline-block bg-[#0c2340] text-white font-bold px-6 py-3 rounded-xl">
                {t('carvana.success.home', 'Retour à l\'accueil')}
              </Link>
            </>
          )}
          {status && status.payment_status !== 'paid' && (
            <>
              <h2 className="text-2xl font-black text-slate-900 mb-2">{t('carvana.success.pending', 'Paiement en attente')}</h2>
              <p className="text-slate-600">{t('carvana.success.retry', 'Cela peut prendre quelques secondes. Ne fermez pas cette page.')}</p>
            </>
          )}
        </div>
      </main>
      <Footer />
    </div>
  );
}
